// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestFollowLine {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _eraseBtn?: vf.gui.Button;
    private _restorBtn?: vf.gui.Button;
    private _followLineTop?: vf.gui.FollowLine;
    private _followLineDown?: vf.gui.FollowLine;
    private _slider?: vf.gui.Slider;
    private _buttonList: vf.gui.Label[] = [];

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {


        const messageList: string[] = [];


        /** 绘制矩形 */
        const rect  = new vf.gui.Rect();
        rect.x = 350;
        rect.y = 50;
        rect.style.width = 100;
        rect.style.height = 100;
        rect.color = "#00ff00";
        rect.lineColor = "#ffffff";
        rect.lineWidth = 1;
        rect.radius = 10; //圆角
        rect.anchorX = 0.5;
        rect.anchorY = 0.5;
        uiStage.addChild(rect);
        rect.interactabled = true;
        rect.on("click",()=>{
            console.log("我被点击了");
        })

        const eraseBtn = this._eraseBtn = new vf.gui.Button();
        eraseBtn.x = 15
        eraseBtn.y = 15;
        eraseBtn.text = '擦除 false';
        uiStage.addChild(eraseBtn);

        const restorBtn = new vf.gui.Button();
        restorBtn.x = 130
        restorBtn.y = 15;
        restorBtn.text = '重置';
        uiStage.addChild(restorBtn);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const followLineTop = this._followLineTop = new vf.gui.FollowLine();
        followLineTop.interactabled = true;
        followLineTop.interactive = true;
        followLineTop.x = 250;
        followLineTop.y = 50;
        followLineTop.width = 340;
        followLineTop.height = 200;
        followLineTop.style.backgroundColor = 0xffffff;
        followLineTop.role = vf.gui.Enum.FollowLineEnum.Role.teacher;
        uiStage.addChild(followLineTop);



        const followLineDown = this._followLineDown = new vf.gui.FollowLine();
        followLineDown.x = 250;
        followLineDown.y = 270;
        followLineDown.width = 340;
        followLineDown.height = 200;
        followLineDown.style.backgroundColor = 0xffffff;
        followLineDown.role = vf.gui.Enum.FollowLineEnum.Role.student;
        uiStage.addChild(followLineDown);

        const slider = this._slider = new vf.gui.Slider();
        slider.vertical = false;
        slider.thumb = "assets/skin/Slider/thumb.png";
        slider.track = "assets/skin/Slider/track.png";
        slider.tracklight = "assets/skin/Slider/tracklight.png";
        slider.width = 340;
        slider.height = 10;
        slider.x = 250;
        slider.y = 480;
        slider.value = 0;
        slider.maxValue = messageList.length;
        uiStage.addChild(slider);
        
        slider.on(vf.gui.Interaction.ComponentEvent.CHANGE, (slider: vf.gui.CheckBox, curValue: number) => {
            followLineDown.clear();
            followLineTop.clear();
            for (let i = 0; i < curValue; i++) {
                if (messageList[i]) {
                    followLineDown.setData(messageList[i]);
                    followLineTop.setData(messageList[i]);
                }
            }
        });

        followLineTop.on(vf.gui.Interaction.ComponentEvent.COMPLETE, (display: vf.gui.FollowLine, data: string) => {
            messageList.push(data);
            console.log(data);
            slider.maxValue = messageList.length;
            followLineDown.setData(data);
        });

        followLineDown.on(vf.gui.Interaction.ComponentEvent.COMPLETE, (display: vf.gui.FollowLine, data: string) => {
            messageList.push(data);
            slider.maxValue = messageList.length;
            followLineTop.setData(data);
        });


        restorBtn.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
            followLineTop.reset();

        });


        this.getButton('设置/取消lineColor', () => {
            if (followLineTop.lineColor !== 0xffcc00) {
                followLineTop.lineColor = 0xffcc00;


            } else {
                followLineTop.lineColor = 0xFF0000;
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消Role', () => {
            if (followLineTop.role !== vf.gui.Enum.FollowLineEnum.Role.student) {
                followLineTop.role = vf.gui.Enum.FollowLineEnum.Role.student;


            } else {
                followLineTop.role = vf.gui.Enum.FollowLineEnum.Role.teacher;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消isErasing', () => {
            if (followLineTop.isErasing !== true) {
                followLineTop.isErasing = true;
            } else {
                followLineTop.isErasing = false;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消isPause', () => {
            if (followLineTop.isPause !== true) {
                followLineTop.isPause = true;


            } else {
                followLineTop.isPause = false;
            }

        }, uiStage, 15, 0);



        let b3: boolean = false;
        let btn3 = this.getButton('设置/取消CHANGE事件', () => {

            if (!b3) {

                b3 = true;
                followLineTop.off(vf.gui.Interaction.ComponentEvent.COMPLETE, hoverFun3);

            } else {
                b3 = false;
                followLineTop.on(vf.gui.Interaction.ComponentEvent.COMPLETE, hoverFun3);
                // basicText.style.left = 600;
                // basicText.style.top = 250;
            }
            function hoverFun3() {
                followLineTop.x += 450;
                followLineTop.y += 50;
            }


        }, uiStage, 15, 0);






















    }



    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        if (this._eraseBtn) {
            this._eraseBtn.removeAllListeners();
            this._eraseBtn.parent && this._eraseBtn.parent.removeChild(this._eraseBtn);
            this._eraseBtn.release();
            this._eraseBtn = undefined;
        }
        if (this._restorBtn) {
            this._restorBtn.removeAllListeners();
            this._restorBtn.parent && this._restorBtn.parent.removeChild(this._restorBtn);
            this._restorBtn.release();
            this._restorBtn = undefined;
        }
        if (this._followLineTop) {
            this._followLineTop.removeAllListeners();
            this._followLineTop.parent && this._followLineTop.parent.removeChild(this._followLineTop);
            this._followLineTop.release();
            this._followLineTop = undefined;
        }
        if (this._followLineDown) {
            this._followLineDown.removeAllListeners();
            this._followLineDown.parent && this._followLineDown.parent.removeChild(this._followLineDown);
            this._followLineDown.release();
            this._followLineDown = undefined;
        }
        if (this._slider) {
            this._slider.removeAllListeners();
            this._slider.parent && this._slider.parent.removeChild(this._slider);
            this._slider.release();
            this._slider = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }
}
